import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "learn-vim-the-smart-way",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#learn-vim-the-smart-way",
        "aria-label": "learn vim the smart way permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Learn Vim the Smart Way`}</h1>
    <h2 {...{
      "id": "whats-this",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#whats-this",
        "aria-label": "whats this permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`What's This?`}</h2>
    <p><em>Learn Vim (the Smart Way)</em> is a guide to learn the good parts of Vim. This project was inspired by Steve Losh' <a target="_blank" href="https://learnvimscriptthehardway.stevelosh.com/">Learn Vimscript the Hard Way</a>. I thought it would be neat to do a broader, albeit less deep, overview of Vim + Vimscript in <span>{new Date().getFullYear()}</span>. So here it is!</p>
    <p>{`This guide consists of three parts:`}</p>
    <ul>
      <li parentName="ul">{`How to use Vim `}</li>
      <li parentName="ul">{`How to customize Vim`}</li>
      <li parentName="ul">{`How to use Vimscript`}</li>
    </ul>
    <p>{`If you're an advanced user already, I would encourage you to read this guide from start to finish anyway, because you will learn something new. `}<a parentName="p" {...{
        "href": "/new-to-vim-read-this-first"
      }}>{`Let's get started!`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      